module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-2"
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "fullscreen"
    },
    model: {
      value: (_vm.isDialogEmail),
      callback: function($$v) {
        _vm.isDialogEmail = $$v
      },
      expression: "isDialogEmail"
    }
  }, [_c('v-card', {
    staticClass: "position-relative",
    attrs: {
      "width": "550",
      "height": "800"
    }
  }, [(!_vm.isLoadingHTML) ? _c('v-card', {
    attrs: {
      "loading": _vm.isLoadingHTML,
      "width": "100%",
      "height": "100%"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.bodyHTML)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "return"
  }, [_c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "color": "primary",
      "dark": "",
      "fab": ""
    },
    on: {
      "click": function($event) {
        return _vm.closeDialog()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1)], 1)], 1)], 1), _c('v-card', {
    staticClass: "mx-auto elevation-1"
  }, [_c('div', {
    staticClass: "d-flex",
    class: {
      'fd-column': _vm.isMovil
    }
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-3 pl-4"
  }, [_c('span', {
    staticClass: "font-weight-700",
    class: {
      'font-size-17': _vm.isMovil
    }
  }, [_vm._v("Notificaciones email")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-13"
  }, [_vm._v("Listado general de notificaciones por email")])], 1), (_vm.isMovil) ? _c('v-divider') : _vm._e(), _c('v-card', {
    staticClass: "d-flex elevation-0 ai-center",
    class: {
      'ma-2': !_vm.isMovil
    }
  }, [_c('v-select', {
    staticClass: "ma-1",
    attrs: {
      "items": _vm.types,
      "item-text": "label",
      "item-value": "value",
      "dense": "",
      "solo": "solo",
      "hide-details": "",
      "label": "Visualizar por"
    },
    on: {
      "change": function($event) {
        return _vm.getFetch()
      }
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }), _c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "color": "primary",
      "small": "small",
      "fab": ""
    },
    on: {
      "click": function($event) {
        return _vm.getFetch()
      }
    }
  }, [_c('v-icon', [_vm._v("sync")])], 1)], 1)], 1), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "box-table",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExcecute",
      "infinite-scroll-distance": "2"
    }
  }, [_c('v-data-table', {
    staticClass: "overflow-y-auto",
    attrs: {
      "headers": _vm.headerTable,
      "dense": "dense",
      "fixed-header": "fixed-header",
      "items": _vm.lista,
      "disable-pagination": true,
      "hide-default-footer": "hide-default-footer",
      "show-expand": "show-expand",
      "single-expand": "single-expand"
    },
    scopedSlots: _vm._u([{
      key: "item.id",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-weight-700 font-size-10"
        }, [_vm._v(_vm._s(item.id))])]
      }
    }, {
      key: "item.fechaRegistro",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-weight-700 font-size-10"
        }, [_vm._v(_vm._s(_vm._f("formatoFecha")(item.fechaRegistro)))])]
      }
    }, {
      key: "item.fechaEnvio",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-chip', {
          attrs: {
            "color": "background"
          }
        }, [(item.enviado) ? _c('span', {
          staticClass: "font-weight-700 font-size-10 success--text"
        }, [_vm._v(_vm._s(_vm._f("formatoFecha")(item.fechaEnvio)))]) : _c('span', {
          staticClass: "font-weight-700 font-size-10 warning--text"
        }, [_vm._v("Todavia no se envia")])])]
      }
    }, {
      key: "item.enviado",
      fn: function(ref) {
        var item = ref.item;

        return [(item.enviado) ? _c('v-icon', {
          attrs: {
            "color": "success"
          }
        }, [_vm._v("check_circle")]) : _c('v-icon', {
          attrs: {
            "color": "warning"
          }
        }, [_vm._v("watch_later")])]
      }
    }, {
      key: "item.asunto",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-weight-700 font-size-11"
        }, [_vm._v(_vm._s(item.asunto))])]
      }
    }, {
      key: "item.usuario",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-weight-700 font-size-11"
        }, [_vm._v(_vm._s(item.usuario))])]
      }
    }, {
      key: "item.conCopiaOculta",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-weight-700 font-size-11"
        }, [_vm._v(_vm._s(item.conCopiaOculta))])]
      }
    }, {
      key: "item.plantilla",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-weight-700 font-size-11"
        }, [_vm._v(_vm._s(item.plantilla))])]
      }
    }, {
      key: "expanded-item",
      fn: function(ref) {
        var headers = ref.headers;
        var item = ref.item;

        return [_c('div', {
          staticClass: "pa-4"
        }, [_c('span', {
          staticClass: "font-weight-700 font-size-11"
        }, [_vm._v(_vm._s(item.destinatarios))])])]
      }
    }, {
      key: "item.actions",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [_c('div', {
          staticClass: "d-flex"
        }, [_c('div', {
          staticClass: "d-flex ai-center",
          class: {
            'ma-1': !_vm.isMovil
          }
        }, [_c('v-btn', {
          staticClass: "mr-2",
          attrs: {
            "x-small": "x-small",
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.openDialog(item.id)
            }
          }
        }, [_c('v-icon', {
          staticClass: "mr-1",
          attrs: {
            "size": "15"
          }
        }, [_vm._v("info")]), _vm._v("plantilla")], 1)], 1)])]
      }
    }])
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09f3d32c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_notificaciones.vue
// module id = 475
// module chunks = 1